<template>
  <v-container>
    <h2>Webinar-Einladung</h2>
    <p>Ihre Einladung wird vorbereitet...</p>
  </v-container>
</template>

<script setup>
import { inject, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore')
const userStore = inject('userStore')
const successStore = inject('successStore')
const errorStore = inject('errorStore')
const { userData } = storeToRefs(userStore)

function redirectToWebinar() {
  const webinarId = route.params.webi_id
  if (!webinarId) {
    errorStore.setError(true, 'Die Webinar-Einladung ist unvollständig.')
    return
  }
  router.replace(`/webinar/${webinarId}`)
}

async function startLogin() {
  const token = route.params.token
  if (!token) {
    errorStore.setError(true, 'Die Webinar-Einladung enthält keinen gültigen Token.')
    return
  }

  loaderStore.setLoader(true, 'Bitte warten, Ihre Webinar-Einladung wird vorbereitet...')

  try {
    const response = await baseCalls.userPost({
      action: 'startlogin',
      token,
    })

    if (response.data.user) {
      userStore.setUser(response.data.user)
      successStore.setSuccess(
        true,
        'Erfolgreich eingeloggt',
        'Sie werden direkt zum Webinar weitergeleitet.'
      )
      redirectToWebinar()
      return
    }

    errorStore.setError(true, 'Die Einladung ist ungültig oder abgelaufen.')
  } catch (err) {
    errorStore.setError(true, 'Fehler beim Laden der Webinar-Einladung.')
    console.error('Fehler beim Einladungs-Login:', err)
  } finally {
    loaderStore.setLoader(false)
  }
}

onMounted(() => {
  if (route.params.token) {
    startLogin()
    return
  }

  if (userData.value) {
    redirectToWebinar()
  } else {
    errorStore.setError(true, 'Die Webinar-Einladung ist ungültig.')
  }
})
</script>
